module.exports = __webpack_public_path__ + "static/media/resume_image.ba407c97.jpeg";